import { faCheck, faPen, faEnvelope, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { format, parse } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useSelector } from "react-redux";
import { maskUC } from "../../infra/utils/maskUC";


const SituacaoConsulta = ({ value }) => {
    switch (value) {
        case 0:
            return (
                <Tooltip title="Em digitação" placement="right" >
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faPen} />
                    </div>
                </Tooltip>
            );
        case 1:
            return (
                <Tooltip title="Aguardando análise" placement="right" >
                    <div className="status_aguardando">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                </Tooltip>
            );
        case 2:
            return (
                <Tooltip title="Concluída" placement="right" >
                    <div className="status_homologado">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                </Tooltip>
            );
        case 4:
            return (
                <Tooltip title="Orçamento arquivada" placement="right" >
                    <div className="status_arquivada">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                </Tooltip>
            );
    }
}

const RendererUnidadeConsumidora = ({ codigoUC }) => {
    const uc = useSelector(state => state.uc);

    if (!codigoUC) {
        return (
            <Tooltip
                title={
                    <span>
                        Orçamento de conexão com ligação nova.
                        <br />
                        (UC não informada)
                    </span>
                }
                placement="top"
            >
                <div className="status_digitacao">
                    <FontAwesomeIcon icon={faX} />
                </div>
            </Tooltip>
        );
    }

    const valorFormatado = uc?.rn1095
        ? maskUC(String(codigoUC))
        : codigoUC;

    return (
        <Tooltip title={valorFormatado} placement="bottom">
            <span>{valorFormatado}</span>
        </Tooltip>
    );
};

const columnsConsulta = [
    {
        field: 'Situacao',
        headerName: 'Situação',
        renderCell: (params) => (
            <SituacaoConsulta value={params.value} />
        )
    },
    { field: 'id', headerName: 'Orç. estimado', flex: 0.3 },
    { field: 'Protocolo', headerName: 'Protocolo', flex: 0.35 },
    {
        field: 'Nome', headerName: 'Nome', flex: 1,
        renderCell: (params) => (
            <Tooltip title={params.value} placement="bottom">
                <p>{params.value}</p>
            </Tooltip>
        )
    },
    {
        field: 'CodigoUC', headerName: 'UC', flex: 0.7,
        renderCell: (params) => (
            <RendererUnidadeConsumidora codigoUC={params?.row?.CodigoUC} />
        )
    },
    {
        field: 'Inscricao', headerName: 'Inscrição', flex: 0.7,
        renderCell: (params) => {
            if (!params.value) {
                return '';
            }

            if (params?.row?.TipoInscricao === 1) {
                return params.value.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, "$1.$2.$3-$4")
            } else {
                return params.value.replace(/([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})/, '$1.$2.$3/$4-$5')
            }
        }
    },
    {
        field: 'Complemento', headerName: 'Complemento', flex: 1,
        renderCell: (params) => (
            <Tooltip title={params.value} placement="bottom">
                <p>{params.value}</p>
            </Tooltip>
        )
    },
    { field: 'TensaoAtendimento', headerName: 'Tensão', flex: 0.35 },
    { field: 'PotenciaInstalada', headerName: 'Potência', flex: 0.35 },
    {
        field: 'PrazoAnalise', headerName: 'Prazo análise', flex: 0.45,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            return dataFormatada.includes("01/01/1900") ? '' : dataFormatada;
        }
    },
    {
        field: 'TipoGeracao.Descricao', headerName: 'Tipo fonte primária', flex: 0.9,
        renderCell: (params) => (
            <Tooltip title={params?.row?.TipoGeracao.Descricao} placement="bottom">
                <p>{params?.row?.TipoGeracao.Descricao}</p>
            </Tooltip>
        )
    },
]

export { columnsConsulta };